import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';

const WikiHero = ({
  title,
  description,
  contentHtml = '',
  overline = 'Wiki TNO Network',
  containerProps = {},
  /** Estilos extra para el bloque del HTML bajo título (p. ej. más ancho en manuales largos). */
  contentHtmlSx = {},
}) => {
  const theme = useTheme();

  return (
    <Box
      minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
      height="auto"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundImage: 'linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(40,40,40,0.9) 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&:after': {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          content: '" "',
          zIndex: 1,
          backgroundColor: theme.palette.primary.dark,
          opacity: 0.75,
        },
      }}
    >
      <Box position="relative" zIndex={2} width="100%">
        <Container {...containerProps}>
          <Box textAlign="center" color="common.white">
            <Box
              sx={{
                backgroundImage: 'url(/images/logos/logo_white.PNG)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                height: { xs: 80, md: 120 },
                maxWidth: 320,
                mx: 'auto',
                mb: 3,
              }}
            />
            <Typography
              sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 1 }}
              variant="overline"
              display="block"
              gutterBottom
            >
              {overline}
            </Typography>
            <Typography variant="h2" fontWeight={900} gutterBottom align="center">
              {title}
            </Typography>
            {description ? (
              <Typography variant="h6" component="p" align="center" sx={{ fontWeight: 400, opacity: 0.95 }}>
                {description}
              </Typography>
            ) : null}
            {contentHtml ? (
              <Box
                sx={{ mt: 2, opacity: 0.9, maxWidth: 720, mx: 'auto', textAlign: 'left', ...contentHtmlSx }}
                component="div"
                dangerouslySetInnerHTML={{ __html: contentHtml }}
              />
            ) : null}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

WikiHero.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  contentHtml: PropTypes.string,
  overline: PropTypes.string,
  /** Props adicionales para `common/Container` (p. ej. `paddingX` más ajustado en una wiki concreta). */
  containerProps: PropTypes.object,
  contentHtmlSx: PropTypes.object,
};

export default WikiHero;
